import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-research-hkbk-create',
  templateUrl: './research-hkbk-create.component.html',
  styleUrls: ['./research-hkbk-create.component.scss']
})
export class ResearchHkbkCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  submitted = false;
  public Form: FormGroup;
  public editorContent: string = '';

  public editorConfig = {
    allowedContent: true, // disables filtering, keeps styles
    extraAllowedContent: 'p(style);div(style);img(style); h1(style); h2(style); h3(style);h4(style); h5(style); h6(style); span(style);', // allows styles on specific tags
  
  };
  ngOnInit() {
    
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/researchHkbkbyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              _id: data.data._id,
              type: data.data.type,
              heading: data.data.heading,
              description: data.data.description,
              image: data.data.image,
              seohidden: data.data.seohidden
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });


    this.Form = this.formBuilder.group({
      type: ['', Validators.required],
      heading: ['', Validators.required],
      description: ['', Validators.required],
      image: ['', Validators.required],
      _id: [''],
      seohidden: ['']
    })
  }

  get f() { return this.Form.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if(this.action == 'Submit'){
    
    var data = {
      "type" : this.Form.value.type,
      "heading" : this.Form.value.heading,
      "description" : this.Form.value.description,
      "image" : this.Form.value.image,
      "admin" : sessionStorage.getItem('adminName'),
      "seohidden": this.Form.value.seohidden
    };
    // console.log(data);
    this.http.post<any>(this.api_endpoint+'/researchHkbk', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/research-hkbk/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }else{
    var data1 = {
      "type" : this.Form.value.type,
      "heading" : this.Form.value.heading,
      "description" : this.Form.value.description,
      "image" : this.Form.value.image,
      "admin" : sessionStorage.getItem('adminName'),
      "_id" : this.Form.value._id,
      "seohidden": this.Form.value.seohidden
    };
      // console.log(data1);     
      this.http.put<any>(this.api_endpoint+'/researchHkbk/', data1).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/research-hkbk/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  }

}
